/**
 * An enum represents user access level
 */
export enum AccessLevel {
  READ = 'Read',
  WRITE = 'Write',
  ADMIN = 'Admin',
}
